const DAILY_BADGES=[
 {id:'daily-champion',name:'Günün Şampiyonu',title:'Günün Şampiyonu',description:'En az 10 pozitif puanlı katılımcı arasında birinci ol.',art:0},
 {id:'daily-podium',name:'Günlük Podyum',title:'Podyum Oyuncusu',description:'En az 10 pozitif puanlı katılımcı arasında ilk 3’e gir.',art:1},
 {id:'daily-top10',name:'İlk %10',title:'Zirve Takipçisi',description:'En az 20 pozitif puanlı katılımcı arasında ilk %10’a gir.',art:2},
 {id:'daily-reference',name:'Referansı Aştı',title:'Referans Ustası',description:'Günlük referans puanını aş.',art:3},
 {id:'daily-streak3',name:'3 Günlük Seri',title:'İstikrarlı Oyuncu',description:'Kesintisiz 7 günlük döngünün 3. gününü tamamla.',art:4},
 {id:'daily-streak7',name:'7 Günlük Seri',title:'Haftalık Müdavim',description:'Kesintisiz 7 günlük döngünün 7. gününü tamamla.',art:5},
];
function badgeByName(name){return DAILY_BADGES.find(b=>b.name===name);}
module.exports={DAILY_BADGES,badgeByName};
